import React, { FC, useEffect, useState } from 'react';

import { IEventEnrollment } from '../../../../store/player/events/store';

import Input from '../../../../components/Input';
import List from '../../../../components/Lists/List/List';
import PlayerListItem from '../../../../components/PlayerListItem/PlayerListItem';
import { getEnrollmentsIdsInEventTeesheet } from '../../../../components/Utils/getEnrollmentsIdsInEventTeesheet';
import { useGetPlayerEvent } from '../../../../contrib/Hooks/useGetPlayerEvent';
import { IListFilter } from '../../../../components/Lists/Utils/IListFilter';

interface IProps {
  clubId: number;
  enrollments: IEventEnrollment[];
  eventId: string;
  invertFiltersOrder?: boolean;
  invitedFilterLabel?: string;
  registeredFilterLabel?: string;
}

const PlayerLookup: FC<IProps> = props => {
  const {
    clubId,
    enrollments,
    invitedFilterLabel,
    registeredFilterLabel,
    invertFiltersOrder,
    eventId
  } = props;

  const [searchValue, setSearchValue] = useState('');
  const event = useGetPlayerEvent(eventId);
  const [playersIdsInTeesheet, setPlayersIdsInTeesheet] = useState<number[]>([]);
  const [listFilters, setListFilters] = useState<Array<IListFilter<IEventEnrollment>>>([]);

  const search = (evnt: any): void => {
    setSearchValue(evnt.target.value);
  };

  const filter = (enrollment: IEventEnrollment): boolean => {
    const name = `${enrollment.user.firstName} ${enrollment.user.lastName}`;

    return searchValue ? name.toUpperCase().includes(searchValue.toUpperCase()) : true;
  };

  useEffect(() => {
    if (event) {
      const enrollmentsIdsInEventTeesheet = getEnrollmentsIdsInEventTeesheet(event);

      setPlayersIdsInTeesheet(enrollmentsIdsInEventTeesheet);
    }
  }, [event]);

  useEffect(() => {
    const filtersArray: Array<IListFilter<IEventEnrollment>> = [
      {
        callback: (enrollment: IEventEnrollment) =>
          enrollment.status === 'active' || playersIdsInTeesheet.includes(enrollment.id),
        label: registeredFilterLabel || 'REGISTERED'
      },
      {
        callback: (enrollment: IEventEnrollment) =>
          (enrollment.status === 'waiting' || enrollment.status === 'invited') &&
          !playersIdsInTeesheet.includes(enrollment.id),
        label: invitedFilterLabel || 'ALL INVITED'
      }
    ];

    setListFilters(invertFiltersOrder ? filtersArray : filtersArray.reverse());
  }, [invertFiltersOrder, playersIdsInTeesheet, registeredFilterLabel]);

  return (
    <div className="event-player-lookup wrapper">
      <Input
        value={searchValue}
        label="PLAYER LOOKUP"
        placeholder="PLAYER LOOKUP"
        outlined={true}
        id="player-lookup"
        type="search"
        classes={{ root: 'search-input' }}
        onChange={search}
      />

      <List
        items={enrollments}
        customFilter={filter}
        filters={listFilters}
        renderItem={PlayerListItem as any}
        context={{ clubId }}
      />
    </div>
  );
};

export default PlayerLookup;
